export * from './delete-objekt-nutzung.service';
export * from './delete-objekt-nutzung.service.module';